// Module Vuex pour cameraViewer
const state = { 
  data: null, 
  loading: false, 
  error: null 
}

const mutations = {
  SET_DATA(state, data) { 
    state.data = data 
  },
  SET_LOADING(state, loading) { 
    state.loading = loading 
  },
  SET_ERROR(state, error) { 
    state.error = error 
  }
}

const actions = {
  // Action pour ouvrir le viewer avec un contexte
  open({ commit }, context) { 
    commit('SET_DATA', context)
    commit('SET_ERROR', null)
  },
  
  // Action pour fermer le viewer
  close({ commit }) {
    commit('SET_DATA', null)
    commit('SET_ERROR', null)
  },
  
  setData({ commit }, data) { 
    commit('SET_DATA', data) 
  },
  
  setLoading({ commit }, loading) { 
    commit('SET_LOADING', loading) 
  },
  
  setError({ commit }, error) { 
    commit('SET_ERROR', error) 
  }
}

const getters = {
  data: state => state.data,
  loading: state => state.loading,
  error: state => state.error,
  isOpen: state => state.data !== null
}

export default { namespaced: true, state, mutations, actions, getters }
